module.exports = angular.module('cartographer.app.api.workspace', [])

_ = require 'underscore'

module.exports.factory 'crtWorkspace', $DI (
  crtLog
  $q
  $rootScope
  $window
  $state
  crtConfig
  crtWebApp
  crtPromise
  crtStorage
  crtHttp
  crtWorkspaceFeature
) ->
  # Default workspace config, used if we can't determine
  # the current workspace from the URL.
  fallback =
    name      : "Cartographer"
    subdomain : "demo"
    homepage  : "http://demo.#{crtConfig.baseDomain}"
    surveys   : []
    layers    : []
    roles     : [ "registered:demo", "active:demo", "userAdmin:demo" ]

  _all     = []
  _current = null

  scopeSubdomain = (scope) ->
    if scope == '*' then 'admin' else scope

  subdomainScope = (subdomain) ->
    if subdomain == 'admin' then '*' else subdomain

  all = ->
    # crtLog.debug('crtWorkspace.all', _all)
    _all

  # string -> or(workspace null)
  find = (ref) ->
    _.find(all(), (workspace) -> workspace.id == ref || workspace.subdomain == ref)

  current = ->
    # crtLog.debug('crtWorkspace.current', _current)
    _current

  currentScope = ->
    if crtConfig.local
      crtStorage.get('LocalWorkspace', 'demo')
    else
      subdomainScope($window.location.hostname.split('.')[0])

  currentWorkspaceId = ->
    current()?.id

  # All roles for the given subdomain, including roles that only superusers can see:
  roles = (workspace = _current) ->
    ans = workspace?.roles ? []
    # crtLog.debug('crtWorkspace.roles', workspace, ans)
    ans

  # All roles for all workspaces, including roles that only superusers can see:
  allRoles = () ->
    ans = [ "superuser" ].concat _.chain(_all).map((workspace) -> workspace.roles).flatten().value()
    # crtLog.debug('crtWorkspace.allRoles', ans)
    ans

  setCurrent = (scope) ->
    # crtLog.debug('crtWorkspace.setCurrent', scope)
    subdomain = scopeSubdomain(scope)
    _current = _.find(_all, (workspace) -> workspace.subdomain == subdomain)
    $rootScope.$broadcast('change:workspace', _current, _all)
    return

  setAll = (workspaces, scope) ->
    # crtLog.debug('crtWorkspace.setAll', workspaces, scope)
    _all = workspaces
    setCurrent(scope)
    return

  changeWorkspace = (scope, go = undefined) ->
    crtLog.debug('crtWorkspace.changeWorkspace', scope)
    crtStorage.set('LocalWorkspace', scope)

    actuallyChange = (scope) ->
      if crtConfig.local
        setCurrent(scope)
        $window.location = "//#{crtConfig.baseDomain}#{go ? ""}"
      else
        $window.location = "//#{scopeSubdomain(scope)}.#{crtConfig.baseDomain}#{go ? ""}"

    read(scope).then(
      (workspace) ->
        if workspace.features? && workspace.features.includes(crtWorkspaceFeature.RedirectToReact)
          url = crtWebApp.workspaceHomeUrl(scope)
          crtLog.debug("Heading to React web app", url)
          $window.location.replace(url)
        else
          actuallyChange(scope)
      (error) ->
        actuallyChange(scope)
    )
    return

  # string [handlers] -> promise(array(workspace))
  search = (options = {}, handlers = null) ->
    crtHttp.get("#{crtConfig.api.rootUrl}/workspace/v1", options, handlers)

  blank = (options = {}) ->
    crtHttp.get("#{crtConfig.api.rootUrl}/workspace/v1/blank", options)

  # string [handlers] -> promise(workspace)
  read = (subdomain, handlers = null) ->
    crtHttp.get("#{crtConfig.api.rootUrl}/workspace/v1/#{subdomain}", {}, handlers)

  # string [handlers] -> promise(workspace)
  readWithEmails = (subdomain, handlers = null) ->
    crtHttp.get("#{crtConfig.api.rootUrl}/workspace/v1/#{subdomain}", { emails: true }, handlers)

  # A promise of the default workspace for the current URL.
  # -> promiseOf(workspace)
  readCurrent = ->
    # crtLog.debug('crtWorkspace.readCurrent', _current)
    if current()
      # crtLog.debug('crtWorkspace.readCurrent', 'shortcut', current(), scope)
      crtPromise.create(current())
    else
      scope = currentScope()
      # crtLog.debug('crtWorkspace.readCurrent', 'search', current(), scope)
      search("", crtHttp.identityHandlers).then(
        (response) ->
          # crtLog.debug('crtWorkspace.readCurrent', 'resolved', response, scope)
          setAll(response.results, scope)
          _current
        ->
          # crtLog.debug('crtWorkspace.readCurrent', 'rejected', fallback, fallback.subdomain)
          setAll([ fallback ], fallback.subdomain)
          fallback
      )

  save = (workspace) ->
    crtHttp.put("#{crtConfig.api.rootUrl}/workspace/v1/#{workspace.id}", workspace)

  return {
    all
    find
    current
    currentScope
    currentWorkspaceId
    scopeSubdomain
    subdomainScope
    allRoles
    roles
    setCurrent
    changeWorkspace
    search
    blank
    read
    readWithEmails
    readCurrent
    save
  }
